<template>
  <v-dialog
    v-model="dialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading">
     <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{newTitle}}</span>
        <v-spacer></v-spacer>
          <v-btn
            text
            icon
            title="Cancelar"
            class="my-2"
            @click="cancelAction"
          >
            <v-icon right dark>mdi-close-circle</v-icon>
          </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text id="dialogBody" class="mt-5 px-3 px-sm-4 px-md-6">

        <ChartOfAccountsIndex
          @index-loading="indexLoading"
          @chart-selected="chartOfAccountSelected"
          :readOnly="true"
          :loadActiveChartOfAccount="loadActiveChartOfAccount"
          :unableToSelectParentNodes="unableToSelectParentNodes"
          :subtreesOfCodes="subtreesOfCodes"
        />

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-row>
          <v-col cols="12" v-if="chartOfAccountSeleted">
            <p class="mx-1 mb-0">
              Plano selecionado:
              <span class="mx-1 font-weight-black">
                {{chartOfAccountSeleted.text}}
              </span>
            </p>
          </v-col>

          <v-col cols="12" style="display: inline-flex">
            <v-btn class="my-2" @click="cancelAction">
              {{newCancelButtonLabel}}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn color="success" class="my-2" @click="confirmAction">
              {{newSaveButtonLabel}}
              <v-icon right dark>mdi-checkbox-marked-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ChartOfAccountsIndex from "./index.vue";

export default {
  // name: "ChartOfAccountSelect",
  data() {
    return {
      chartOfAccountSeleted: null,
      dialog: false,
    };
  },
  components: {
    ChartOfAccountsIndex: ChartOfAccountsIndex,
  },
  props: {
    // dialog: {
    //   type: Boolean,
    //   default: true
    // },
    createButtonDisabled: {
      type: Boolean,
      default: false
    },
    unableToSelectParentNodes: {
      type: Boolean,
      default: true
    },
    subtreesOfCodes: {
      type: Array,
      default: () => null
    },
    formErrors: {
      type: Array,
      default: () => []
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    addButtonIcon: {
      type: String,
      default: "mdi-plus"
    },
    newTitle: {
      type: String,
      default: "Criação de Registro"
    },
    newCreateButtonLabel: {
      type: String,
      default: "Novo Cadastro"
    },
    newCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    newSaveButtonLabel: {
      type: String,
      default: "Salvar"
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    loadActiveChartOfAccount: {
      type: Object,
      default: null
    }
  },
  watch: {
    formErrors: function(val) {
      if (val && val.length > 0) {
        // document.getElementById('dialogBody').scrollTop = 0;
        let options = {
          container: '#dialogBody',
          duration: 300,
          offset: 0,
        }
        this.$vuetify.goTo(0, options);
      }
    }
  },
  methods: {
    cancelAction: function(){
      this.closeDialog();
      this.$emit("select-cancel-action")
    },
    confirmAction: function(){
      this.closeDialog();
      this.$emit("select-confirm-action", this.chartOfAccountSeleted)
    },
    openAction: function() {
      this.$emit("select-open-action")
    },
    openDialog: function() {
      this.dialog = true;
    },
    closeDialog: function() {
      this.dialog = false;
    },
    errorsAlertClose: function(val) {
      if (!val) {
        this.$emit("clear-form-errors");
      }
    },
    indexLoading: function(val){
      this.loading = val;
    },
    chartOfAccountSelected: function(val) {
      // console.log(val);
      if(val && val.length > 0) {
        this.chartOfAccountSeleted = val[0];
      } else {
        this.chartOfAccountSeleted = null;
      }
    }
  },
};
</script>

<style scoped></style>
